import { render } from "./MerchantList.vue?vue&type=template&id=aa1decec&scoped=true"
import script from "./MerchantList.vue?vue&type=script&lang=js"
export * from "./MerchantList.vue?vue&type=script&lang=js"

import "./MerchantList.vue?vue&type=style&index=0&id=aa1decec&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa1decec"]])

export default __exports__